import { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

import { useSvgId } from 'src/lib/hooks';

export const IconChannelOutreach = memo(
  forwardRef((props, ref) => {
    const svgId = useSvgId();

    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 24 24"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.6728 0.75C14.3487 0.75 19.9024 1.89855 22.4874 4.53284C23.1431 5.20094 24 6.5083 24 8.42405C24 11.8308 21.3065 17.0569 18.3322 20.0878C16.7947 21.6544 14.3487 23.7024 11.0584 23.7024C7.84262 23.7024 5.38608 21.476 4.67489 20.7513C1.95103 17.9756 0 13.7624 0 9.83364C0 7.35599 0.693189 5.18808 2.46223 3.38586C4.10091 1.71616 6.92475 0.75 10.6728 0.75ZM15.2227 14.3338C16.4637 13.069 16.798 11.511 16.798 10.6538C16.798 10.0319 16.637 9.12027 15.8741 8.34325C14.7034 7.15033 13.4077 6.8137 11.9976 6.8137C10.2115 6.8137 9.01155 7.38873 8.21177 8.20369C7.58493 8.8424 7.0428 9.82445 7.0428 11.2193C7.0428 12.6136 7.77295 13.9604 8.56824 14.7708C9.3023 15.5185 10.4565 16.0733 11.6192 16.0733C12.7821 16.0733 13.9817 15.5986 15.2227 14.3338Z"
          fill={`url(#${svgId})`}
        />
        <defs>
          <linearGradient
            id={svgId}
            x1="1200"
            y1="2295.99"
            x2="1200"
            y2="0.75"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#443EC2" />
            <stop
              offset="1"
              stopColor="#5951FF"
            />
          </linearGradient>
        </defs>
      </SvgIcon>
    );
  })
);
